import { createSelector } from "reselect";
import moment from "moment";
import {
  getMonths,
  years,
} from "../components/clients/edit-client/side-bar-child/child-events/create-invoice";

export const getInvoiceSelector = (state) => {
  return state.discount.invoice;
};

export const getInvoiceClientSelector = createSelector(
  [getInvoiceSelector],
  (invoice) => {
    const dayNow = moment().format("YYYY-MM-DD HH:mm");
    const newInvoice = {
      ...invoice,
      name: moment(invoice.valid_from).format("MMMM"),
      missed: invoice.training?.filter(
        (item) => item.state_training_children.id === 2
      ).length,
      balance: invoice.training?.filter(
        (el) =>
          moment(el.schedule.start).isSame(dayNow) ||
          moment(dayNow).isBefore(el.schedule.start)
      ).length,
    };
    const training = invoice.training
      ?.map((item) => ({
        ...item,
        startDesktop: moment(item.schedule.start).format("DD MMMM YYYY"),
        start: `${moment(item.schedule.start).format("dd DD.MM.YYYY")} ${moment(
          item.schedule.start
        ).format("HH:mm")}-${moment(item.schedule.start, "YYYY-mm-dd HH:mm")
          .add(item.schedule.duration, "minutes")
          .format("HH:mm")}`,
      }))
      .sort(function (a, b) {
        return new Date(a.schedule.start) - new Date(b.schedule.start);
      });
    return { ...newInvoice, training };
  }
);

export const getScheduleGroupClientSelector = (state) => {
  return state.selects.scheduleGroup;
};

export const getCreateInvoiceClientSelector = createSelector(
  [getScheduleGroupClientSelector, (state, childInvoices) => childInvoices],
  (schedule, childInvoices) => {
    const childSchedule = childInvoices
      .map((item) => item.training.map((el) => el.schedule))
      .flat(1);
    const days = moment.weekdays();
    const monthNow = moment().format("MMMM");
    const yearNow = moment().format("YYYY");
    const monthsList = moment.months().map((el, index) => ({
      id: index,
      name: el,
    }));
    const yearsList = years(20).map((el, index) => ({
      id: index,
      name: el.toString(),
    }));
    const dayList = days.concat(days.shift()).map((item, index) => ({
      id: index,
      name: item,
    }));
    const month = monthsList.find((el) => el.name === monthNow);
    const year = yearsList.find((el) => el.name === yearNow);
    const dateMonth = getMonths(month.name, year.name);
    const scheduleMonthGroup = schedule.map((el) => ({
      id: el.id,
      start: moment(el.start).format("HH:mm"),
      end: moment(moment(el.start).format("HH:mm"), "HH:mm")
        .add(el.duration, "minutes")
        .format("HH:mm"),
      dayName: moment(el.start).format("dddd"),
      day: moment(el.start).format("D MMMM"),
      duration: el.duration,
      date: el.start,
      month: moment(el.start).format("MMMM"),
      year: moment(el.start).format("YYYY"),
    }));

    const childArray = scheduleMonthGroup.filter(
      (o) => !childSchedule.find((o2) => o.id === o2.id)
    );
    const sortScheduleMonth = childArray.sort(
      (a, b) => moment(a.date) - moment(b.date)
    );

    return {
      sortScheduleMonth,
      year,
      month,
      monthsList,
      yearsList,
      dayList,
      dateMonth,
    };
  }
);
